import React from 'react';
import './style.scss';

interface UserQueryMessageBubbleProps {
    /** The user's message text */
    text: string;
}

const UserQueryMessageBubble: React.FC<UserQueryMessageBubbleProps> = ({ text }) => {
    return (
        <div className="user-query-message-row">
            <div className="user-query-message-bubble">
                <span className="user-query-message-text">{text}</span>
            </div>
        </div>
    );
};

export default UserQueryMessageBubble;
